"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Name = void 0;
exports.Name = 'Token Pocket';



//////////////////
// WEBPACK FOOTER
// ./node_modules/ual-token-pocket/dist/interfaces.js
// module id = t5ms
// module chunks = 1